import React, { useState } from "react";
import { SystemConstant } from "const";
import { makeStyles } from "@mui/styles";
import { Heading, BranchRequestListTable } from "./components";
import { useBranchRequestList } from "hooks";
import { debounce } from "lodash";

const UserRequestManagement = props => {
  const classes = useStyles();
  const { status } = props;

  const [checkedUsers, setCheckedUsers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);

  const { branchRequestList, pagination, refetch, isFetching } = useBranchRequestList({
    page: page,
    filter: searchInput,
    status: status,
  });

  const handleChangeSearchInput = event => {
    setSearchInput(event.target.value);
    setPage(1);
  };

  const handleCheckboxChange = (isCheckAll, isChecked, id) => {
    if (isCheckAll) {
      if (isChecked) {
        setCheckedUsers(
          branchRequestList
            .filter(data => data.status === SystemConstant.BRANCH_REQUEST_STATUS.REJECTED.status)
            .map(data => data.id),
        );
      } else {
        setCheckedUsers([]);
      }
    } else {
      if (isChecked) {
        setCheckedUsers(state => [...state, id]);
      } else {
        setCheckedUsers(state => state.filter(index => index !== id));
      }
    }
  };

  const handleChangePage = (e, page) => {
    setPage(page);
  };

  return (
    <>
      <Heading
        searchInput={searchInput}
        choosedStatus={status}
        onChangeSearchInput={debounce(handleChangeSearchInput, 500)}
        checkedUsers={checkedUsers}
        setCheckedUsers={setCheckedUsers}
        refetch={refetch}
      />

      <BranchRequestListTable
        isLoading={isFetching}
        branchRequestList={branchRequestList}
        pagination={pagination}
        onCheckBoxChange={handleCheckboxChange}
        checkedUsers={checkedUsers}
        onChangePage={handleChangePage}
        refetch={refetch}
      />
    </>
  );
};

export default UserRequestManagement;

const useStyles = makeStyles(theme => ({}));
